import React, {
  useState,
  forwardRef,
  useImperativeHandle,
  useEffect,
  useRef,
} from 'react';

import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  Paper,
} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import { green } from '@material-ui/core/colors';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogActions from '@material-ui/core/DialogActions';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import Slide from '@material-ui/core/Slide';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CloseIcon from '@material-ui/icons/Close';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import ScheduleIcon from '@material-ui/icons/Schedule';
import StopIcon from '@material-ui/icons/Stop';
import moment from 'moment';
import { useSnackbar } from 'notistack';

import { AutoCompleteLocal } from '../../Components';
import { getUserId } from '../../services';
import api, { getListAllAPI, updateAPI } from '../../services/api';
import {
  SECONDARY_COLOR,
  getPrecoUnitarioVerdadeiroCaixa2,
  LABEL_TIPO_CAIXA_CAIXA,
  LABEL_TIPO_CAIXA_FARDO,
  LABEL_TIPO_CAIXA_GALÉIA,
  LABEL_TIPO_CAIXA_SACO,
  POR_PESO_FIXO,
  POR_PESO_VARIAVEL_SEM_UNIDADE,
  POR_UNIDADE,
  TIPO_IMPRESSAO_UN,
  formatMoeda,
  formatPeso,
  formatPreco,
} from '../../utils';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: 'white',
  },
});

const Transition = React.forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6" style={{ fontWeight: 'bold' }}>
        {children}
      </Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const useStyles = makeStyles((theme) => ({
  rootDialogo: {
    borderRadius: '25px',
  },
  btnAtions: {
    borderRadius: '25px',
  },
  btnAtionsDisabled: {
    borderRadius: '25px',
  },
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative',
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}));

const mapaLabelTipoCaixa = {
  [LABEL_TIPO_CAIXA_CAIXA]: 'Caixa',
  [LABEL_TIPO_CAIXA_FARDO]: 'Fardo',
  [LABEL_TIPO_CAIXA_GALÉIA]: 'Galéia',
  [LABEL_TIPO_CAIXA_SACO]: 'Saco',
};

function PrintingStatus() {
  const [dotCount, setDotCount] = React.useState(0);

  React.useEffect(() => {
    const interval = setInterval(() => {
      setDotCount((prev) => (prev >= 3 ? 0 : prev + 1));
    }, 500);

    return () => clearInterval(interval);
  }, []);

  return (
    <span style={{ display: 'inline-block', minWidth: 90 }}>
      Imprimindo
      <span style={{ display: 'inline-block', width: 20 }}>
        {'.'.repeat(dotCount)}
      </span>
    </span>
  );
}

const useStylesCell = makeStyles((theme) => ({
  /* statusContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  }, */
  printed: {
    color: '#4caf50',
  },
  pending: {
    color: '#ff9800',
  },
  headerCell: {
    backgroundColor: SECONDARY_COLOR, // azul escuro moderno
    color: '#fff',
    fontWeight: 600,
    fontSize: 14,
  },
  printingRow: {
    backgroundColor: 'rgba(25, 118, 210, 0.08)', // azul leve
    transition: 'background-color 0.3s ease',
    animation: '$pulse 1.5s infinite',
  },

  '@keyframes pulse': {
    '0%': { backgroundColor: 'rgba(25, 118, 210, 0.05)' },
    '50%': { backgroundColor: 'rgba(25, 118, 210, 0.12)' },
    '100%': { backgroundColor: 'rgba(25, 118, 210, 0.05)' },
  },

  statusContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    fontWeight: 500,
  },

  printingText: {
    color: '#1976d2',
    fontWeight: 600,
  },
}));

function StatusCell({ status }) {
  const classes = useStylesCell();

  if (status === 'printed') {
    return (
      <div className={classes.statusContainer}>
        <CheckCircleIcon className={classes.printed} />
        <span>Impresso</span>
      </div>
    );
  }

  if (status === 'printing') {
    return (
      <div className={classes.statusContainer}>
        <CircularProgress size={18} thickness={5} />
        <span className={classes.printingText}>
          <PrintingStatus />
        </span>
      </div>
    );
  }

  return (
    <div className={classes.statusContainer}>
      <ScheduleIcon className={classes.pending} />
      <span>Pendente</span>
    </div>
  );
}

function ImpressaoTable({
  rows,
  filas,
  filaAtual,
  statusImpressao,
  handleFilaAtual,
  handleStatus,
}) {
  const printingRef = useRef(null);

  const classes = useStylesCell();

  useEffect(() => {
    if (printingRef.current) {
      printingRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center', // centraliza na tela
      });
    }
  }, [rows]);

  return (
    <div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <AutoCompleteLocal
          handleEnter={() => {}}
          label="Fila"
          handleKey={() => {}}
          value={filaAtual}
          onChangeLocal={(value) => {
            handleFilaAtual(value);
          }}
          campo="username"
          options={filas}
          disabled={statusImpressao}
        />
        {filaAtual ? (
          <Button
            variant="contained"
            startIcon={!statusImpressao ? <PlayArrowIcon /> : <StopIcon />}
            style={{
              backgroundColor: !statusImpressao ? '#2e7d32' : '#d32f2f',
              color: '#fff',
              marginLeft: '30px',
              height: 50,
            }}
            onClick={handleStatus}
          >
            {!statusImpressao ? 'Iniciar' : 'Parar'}
          </Button>
        ) : null}
      </div>
      <TableContainer component={Paper} style={{ maxHeight: 400 }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell className={classes.headerCell}>Status</TableCell>
              <TableCell className={classes.headerCell}>Produto</TableCell>
              <TableCell className={classes.headerCell}>Horário</TableCell>
              <TableCell className={classes.headerCell}>Cópias</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {rows.map((row) => {
              const isPrinting = row.status === 'printing';
              return (
                <TableRow
                  key={row.id}
                  className={
                    row.status === 'printing' ? classes.printingRow : ''
                  }
                  ref={isPrinting ? printingRef : null}
                >
                  <TableCell>
                    <StatusCell status={row.status} />
                  </TableCell>
                  <TableCell>{row.produto}</TableCell>
                  <TableCell>{row.horario}</TableCell>
                  <TableCell>{row.copias}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}

const rows = [
  {
    id: 1,
    produto: 'Produto A',
    horario: '14:00',
    copias: 1,
    status: 'printed',
  },
  {
    id: 2,
    produto: 'Produto B',
    horario: '14:01',
    copias: 2,
    status: 'printed',
  },
  {
    id: 3,
    produto: 'Produto C',
    horario: '14:02',
    copias: 1,
    status: 'printed',
  },
  {
    id: 4,
    produto: 'Produto D',
    horario: '14:03',
    copias: 1,
    status: 'printed',
  },
  {
    id: 5,
    produto: 'Produto E',
    horario: '14:04',
    copias: 3,
    status: 'printed',
  },

  {
    id: 6,
    produto: 'Produto F',
    horario: '14:05',
    copias: 2,
    status: 'printing',
  },

  {
    id: 7,
    produto: 'Produto G',
    horario: '14:06',
    copias: 1,
    status: 'pending',
  },
  {
    id: 8,
    produto: 'Produto H',
    horario: '14:07',
    copias: 2,
    status: 'pending',
  },
  {
    id: 9,
    produto: 'Produto I',
    horario: '14:08',
    copias: 1,
    status: 'pending',
  },
  {
    id: 10,
    produto: 'Produto J',
    horario: '14:09',
    copias: 1,
    status: 'pending',
  },
  {
    id: 11,
    produto: 'Produto K',
    horario: '14:10',
    copias: 2,
    status: 'pending',
  },
  {
    id: 12,
    produto: 'Produto L',
    horario: '14:11',
    copias: 1,
    status: 'pending',
  },
  {
    id: 13,
    produto: 'Produto M',
    horario: '14:12',
    copias: 3,
    status: 'pending',
  },
  {
    id: 14,
    produto: 'Produto N',
    horario: '14:13',
    copias: 1,
    status: 'pending',
  },
  {
    id: 15,
    produto: 'Produto O',
    horario: '14:14',
    copias: 2,
    status: 'pending',
  },
  {
    id: 16,
    produto: 'Produto P',
    horario: '14:15',
    copias: 1,
    status: 'pending',
  },
  {
    id: 17,
    produto: 'Produto Q',
    horario: '14:16',
    copias: 1,
    status: 'pending',
  },
  {
    id: 18,
    produto: 'Produto R',
    horario: '14:17',
    copias: 2,
    status: 'pending',
  },
  {
    id: 19,
    produto: 'Produto S',
    horario: '14:18',
    copias: 1,
    status: 'pending',
  },
  {
    id: 20,
    produto: 'Produto T',
    horario: '14:19',
    copias: 2,
    status: 'pending',
  },
];

const optionsLoja = [
  {
    nome: 'CARUARU FRIOS',
    value: 'CF',
  },
  {
    nome: 'CASA DA PIZZA',
    value: 'CP',
  },
];

function delay(ms) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}

function getOrquestradorImpressoes(
  imprimir,
  marcarComoImpresso,
  indicador,
  getEtiquetas,
  indicador2,
) {
  let index = 0;
  let continua = true;

  async function iniciar(dados) {
    continua = true;
    index = 0;
    const etiquetas = dados ? dados : getEtiquetas(); // pega sempre a versão atual

    for (; index < etiquetas.length && continua; index++) {
      indicador(etiquetas[index].id, etiquetas);
      const response = await imprimir(etiquetas[index]);
      const { status } = response;
      if (!status) continua = false;
      await delay(5000);
      if (continua) {
        await marcarComoImpresso(etiquetas[index]);
      }
    }
    if (continua) {
      indicador(-1, etiquetas);
    } else {
      indicador2(getEtiquetas());
    }
  }

  function parar() {
    continua = false;
  }

  return {
    iniciar,
    parar,
  };
}

const DialogoCategoriaTransacao = forwardRef(({ handleClose }, ref) => {
  const [open, setOpen] = useState(false);
  const [filas, setFilas] = useState(optionsLoja);
  const [statusImpressao, setStatusImpressao] = useState(false);
  const [carregando, setCarregando] = useState(true);
  const [filaAtual, setFilaAtual] = useState(null);
  const [etiquetas, setEtiquetas] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  const etiquetasRef = useRef([]);

  const refStatusImpressao = useRef(false);
  const refCarregando = useRef(true);
  const refIsProcessandoStatusImpressao = useRef(false);

  /*   const orquestradorImpressoes = useRef(
    getOrquestradorImpressoes(
      imprimir,
      marcarComoImpresso,
      indicador,
      () => etiquetasRef.current,
      indicador2,
    ),
  ); */

  const orquestradorImpressoes = useRef(null);

  if (!orquestradorImpressoes.current) {
    orquestradorImpressoes.current = getOrquestradorImpressoes(
      imprimir,
      marcarComoImpresso,
      indicador,
      () => etiquetasRef.current,
      indicador2,
    );
  }

  useEffect(() => {
    etiquetasRef.current = etiquetas;
  }, [etiquetas]);

  function indicador(id, etiquetas) {
    const dadosFormatados = [];
    let alcancou = false;

    for (let i = 0; i < etiquetas.length; i++) {
      if (etiquetas[i].id === id) {
        dadosFormatados.push({
          ...etiquetas[i],
          status: 'printing',
        });
        alcancou = true;
      } else {
        if (alcancou) {
          dadosFormatados.push({
            ...etiquetas[i],
            status: 'pending',
          });
        } else {
          dadosFormatados.push({
            ...etiquetas[i],
            status: 'printed',
          });
        }
      }
    }

    setEtiquetas(dadosFormatados);
    if (id < 0) {
      setStatusImpressao(false);
      refStatusImpressao.current = false;
    }
  }

  function indicador2(etiquetas) {
    const dadosFormatados = [];

    for (let i = 0; i < etiquetas.length; i++) {
      if (etiquetas[i].status === 'printing') {
        dadosFormatados.push({
          ...etiquetas[i],
          status: 'pending',
        });
      } else {
        dadosFormatados.push({
          ...etiquetas[i],
        });
      }
    }

    setEtiquetas(dadosFormatados);
  }

  const classes = useStyles();

  const handleCloseDialog = () => {
    setOpen(false);
    setEtiquetas([]);
    setFilaAtual(null);
    handleClose();
    setCarregando(true);
    refCarregando.current = true;
    refStatusImpressao.current = false;
    setStatusImpressao(false);
  };

  async function init() {
    setCarregando(true);
    refCarregando.current = true;
    setEtiquetas([]);
    setFilaAtual(null);
    await getFilas();
    setCarregando(false);
    refCarregando.current = false;
    refStatusImpressao.current = false;
    setStatusImpressao(false);
  }

  useImperativeHandle(ref, () => ({
    handleOpen(id) {
      setOpen(true);
      init();
    },
  }));

  function handleFilaAtual(value) {
    setFilaAtual(value);
  }

  async function handleStatus() {
    if (!refIsProcessandoStatusImpressao.current) {
      refIsProcessandoStatusImpressao.current = true;
      const newValue = !statusImpressao;
      refStatusImpressao.current = !refStatusImpressao.current;
      const dados = await getImpressoes();
      if (newValue) {
        if (dados.length > 0) {
          orquestradorImpressoes.current.iniciar(dados);
          setStatusImpressao(newValue);
          refIsProcessandoStatusImpressao.current = false;
        } else {
          setFilaAtual(null);
        }
      } else {
        orquestradorImpressoes.current.parar();
        setStatusImpressao(newValue);
        refIsProcessandoStatusImpressao.current = false;
      }
    }
  }

  async function getFilas() {
    try {
      const data = await getListAllAPI(
        'users_impressoes',
        ['id', 'asc'],
        {},
        [],
      );
      if (data.data.length > 0) {
        setFilas(data.data);
      } else {
        throw 'Nenhuma fila disponível!';
      }
    } catch (erros) {
      enqueueSnackbar(`Nenhuma fila disponível!`, {
        variant: 'error',
      });
      setFilas([]);
    }
  }

  function formatDados({
    descricao,
    preco,
    tipoUnidade,
    peso_medio,
    tipoImpressao,
    unidades_caixa_nivel_1,
    peso_caixa_nivel_1,
    copias,
    referencia_no_cartaz,
    tipo_label_caixa,
  }) {
    const dadosFormatados = { copias };
    const descricoes = descricao.split('\n');

    switch (descricoes.length) {
      case 0:
        dadosFormatados.descricao = '';
        dadosFormatados.descricao2 = '';
        break;
      case 1:
        dadosFormatados.descricao = descricoes[0];
        dadosFormatados.descricao2 = '';
        break;
      default:
        dadosFormatados.descricao = descricoes[0];
        dadosFormatados.descricao2 = descricoes[1];
        break;
    }

    const stringPreco = formatPreco(preco).trim().split(',');
    dadosFormatados.precoParteInteira = stringPreco[0].trim();
    dadosFormatados.precoParteReal = stringPreco[1].trim();
    dadosFormatados.preco = '';
    dadosFormatados.peso_padrao = '';
    dadosFormatados.PrecoAtacado = '';
    dadosFormatados.QuantidadeCaixa = '';
    dadosFormatados.labelCaixaria = mapaLabelTipoCaixa[tipo_label_caixa];

    switch (tipoUnidade) {
      case POR_PESO_FIXO: {
        if (tipoImpressao === TIPO_IMPRESSAO_UN) {
          dadosFormatados.unidade = 'Un';
          dadosFormatados.preco = formatPreco(preco * peso_medio, 2, '').trim();
          const stringPreco = formatPreco(preco * peso_medio)
            .trim()
            .split(',');
          dadosFormatados.precoParteInteira = stringPreco[0]
            .replace('R$:', '')
            .trim();
          dadosFormatados.precoParteReal = stringPreco[1].trim();
          dadosFormatados.mensagemPesoPadrao = `Peso Padrão de ${formatPeso(
            peso_medio,
          )}`;
        } else {
          dadosFormatados.unidade = 'Kg';
          dadosFormatados.preco = formatPreco(preco, 2, '').trim();
          const stringPreco = formatPreco(preco).trim().split(',');
          dadosFormatados.precoParteInteira = stringPreco[0]
            .replace('R$:', '')
            .trim();
          dadosFormatados.precoParteReal = stringPreco[1].trim();
          dadosFormatados.mensagemPesoPadrao = ``;
        }

        dadosFormatados.peso_padrao = formatPeso(peso_medio, 3, '');

        if (unidades_caixa_nivel_1) {
          const labelCaixa = mapaLabelTipoCaixa[tipo_label_caixa];
          dadosFormatados.labelCaixa = `${labelCaixa} com ${unidades_caixa_nivel_1} por ${formatMoeda(
            unidades_caixa_nivel_1 * preco * peso_medio,
          )}`;

          dadosFormatados.PrecoAtacado = formatPreco(
            unidades_caixa_nivel_1 * preco * peso_medio,
            2,
            '',
          );
          dadosFormatados.QuantidadeCaixa = unidades_caixa_nivel_1;
        } else {
          dadosFormatados.labelCaixa = ``;
        }
        break;
      }
      case POR_UNIDADE: {
        dadosFormatados.unidade = 'Un';
        if (referencia_no_cartaz) {
          dadosFormatados.mensagemPesoPadrao = referencia_no_cartaz;
        } else {
          dadosFormatados.mensagemPesoPadrao = '';
        }
        dadosFormatados.preco = formatPreco(preco, 2, '').trim();
        const stringPreco = formatPreco(preco).trim().split(',');
        dadosFormatados.precoParteInteira = stringPreco[0]
          .replace('R$:', '')
          .trim();
        dadosFormatados.precoParteReal = stringPreco[1].trim();
        if (unidades_caixa_nivel_1) {
          const labelCaixa = mapaLabelTipoCaixa[tipo_label_caixa];
          dadosFormatados.labelCaixa = `${labelCaixa} com ${unidades_caixa_nivel_1} por ${formatMoeda(
            unidades_caixa_nivel_1 * preco,
          )}`;

          dadosFormatados.PrecoAtacado = formatPreco(
            unidades_caixa_nivel_1 * preco,
            2,
            '',
          );
          dadosFormatados.QuantidadeCaixa = unidades_caixa_nivel_1;
        } else {
          dadosFormatados.labelCaixa = ``;
        }
        break;
      }
      case POR_PESO_VARIAVEL_SEM_UNIDADE: {
        dadosFormatados.unidade = 'Kg';
        dadosFormatados.mensagemPesoPadrao = '';
        dadosFormatados.preco = formatPreco(preco, 2, '').trim();
        const stringPreco = formatPreco(preco).trim().split(',');
        dadosFormatados.precoParteInteira = stringPreco[0]
          .replace('R$:', '')
          .trim();
        dadosFormatados.precoParteReal = stringPreco[1].trim();
        if (peso_caixa_nivel_1) {
          const labelCaixa = mapaLabelTipoCaixa[tipo_label_caixa];
          dadosFormatados.labelCaixa = `${labelCaixa} de ${formatPeso(
            peso_caixa_nivel_1,
          )} por ${formatMoeda(peso_caixa_nivel_1 * preco)}`;

          dadosFormatados.PrecoAtacado = formatPreco(
            peso_caixa_nivel_1 * preco,
            2,
            '',
          );
          dadosFormatados.QuantidadeCaixa = formatPeso(peso_caixa_nivel_1);
        } else {
          dadosFormatados.labelCaixa = ``;
        }
        break;
      }
      default:
        break;
    }

    return dadosFormatados;
  }

  function getDadosImpressao(produto) {
    const preco = getPrecoUnitarioVerdadeiroCaixa2(produto);

    const dados = {
      descricao: produto.descricao_no_cartaz,
      preco,
      tipoUnidade: produto.unidade.tipo,
      peso_medio: produto.peso_medio,
      tipoImpressao: produto.tipo_impressao,
      unidades_caixa_nivel_1: produto.unidades_caixa_nivel_1,
      peso_caixa_nivel_1: produto.peso_caixa_nivel_1,
      copias: produto.copias,
      referencia_no_cartaz: produto.referencia_no_cartaz,
      tipo_label_caixa: produto.tipo_label_caixa,
    };

    /* return {
      copias,
      descricao,
      descricao2,
      precoParteInteira,
      precoParteReal,
      mensagemPesoPadrao,
      unidade,
      labelCaixa,
    }; */
    /*    {
  "Descricao": "PRODUTO TESTE",
  "Descricao2": "Linha adicional (opcional)",
  "Preco": "99,99",
  "Unidade": "UN",
  "PrecoAtacado": "950,00",
  "PP": "1,500",
  "QuantidadeCaixa": "10",
  "Data": "11/02/2026"
} */
    return formatDados(dados);
  }

  function formatEtiquetas(dados) {
    const dadosFormatados = [];
    for (let i = 0; i < dados.length; i++) {
      dadosFormatados.push({
        id: dados[i].id,
        produto: dados[i].produto.nome,
        horario: moment(dados[i].horario).format('DD/MM/YYYY - HH:mm'),
        copias: dados[i].copias,
        status: 'pending',
        dadosImpressao: getDadosImpressao({
          ...dados[i].produto,
          ofertasProdutos: dados[i].produto.ofertasProdutos2,
        }),
      });
    }
    return dadosFormatados;
  }

  async function getImpressoes() {
    try {
      const data = await getListAllAPI(
        'solicitacoes_impressoes_etiqueta_2',
        ['horario', 'desc'],
        { status: false, user_id: filaAtual.id },
        ['produto.unidade', 'produto.ofertasProdutos2', 'user'],
      );
      const dadosFormatados = formatEtiquetas(data.data);
      setEtiquetas(dadosFormatados);
      return dadosFormatados;
    } catch (erros) {
      enqueueSnackbar(`Erro ao buscar os registros!`, {
        variant: 'error',
      });
      setEtiquetas([]);
      return [];
    }
  }

  async function getImpressoesAll() {
    try {
      const data = await getListAllAPI(
        'solicitacoes_impressoes_etiqueta_2',
        ['horario', 'desc'],
        { status: false },
        ['produto.unidade', 'produto.ofertasProdutos2', 'user'],
      );
      setEtiquetas(formatEtiquetas(data.data));
    } catch (erros) {
      enqueueSnackbar(`Erro ao buscar os registros!`, {
        variant: 'error',
      });
      setEtiquetas([]);
    }
  }

  async function marcarComoImpresso(dados) {
    const response = await updateAPI(
      'solicitacoes_impressoes_etiqueta',
      dados.id,
      {
        status: true,
        horario: new Date(),
        user_id: getUserId(),
      },
    );
  }

  async function imprimir(dados) {
    try {
      const Descricao = dados.dadosImpressao.descricao;
      const Descricao2 = dados.dadosImpressao.descricao2;
      const Preco = dados.dadosImpressao.preco;
      const Unidade = dados.dadosImpressao.unidade;
      const PrecoAtacado = dados.dadosImpressao.PrecoAtacado;
      const PP = dados.dadosImpressao.peso_padrao;
      const QuantidadeCaixa = dados.dadosImpressao.QuantidadeCaixa;
      const Data = moment().format('DD/MM/YYYY');
      const labelCaixa = dados.dadosImpressao.labelCaixaria;
      const copias = dados.copias;

      const response = await api.post(`http://127.0.0.1:52743/imprimir`, {
        Descricao,
        Descricao2,
        Preco,
        Unidade,
        PrecoAtacado,
        PP,
        QuantidadeCaixa,
        Data,
        labelCaixa,
        copias,
      });

      const { status, message } = response.data;

      if (status) {
        return response.data;
      }

      throw message;

      return {
        status: true,
        message: '',
      };
    } catch (e) {
      return {
        status: false,
        message: e
          ? e.toString()
          : 'Erro desconhecido ao enviar para impressão',
      };
    }
  }

  useEffect(() => {
    if (open) {
      if (filaAtual) {
        getImpressoes();
      } else {
        getImpressoesAll();
      }
    } else {
      setEtiquetas([]);
    }
  }, [filaAtual, open]);

  return (
    <div>
      <Dialog
        open={open}
        aria-labelledby="form-dialog-title"
        classes={{ paper: classes.rootDialogo }}
        className={classes.rootDialogo}
        fullWidth
        maxWidth="md"
        TransitionComponent={Transition}
        keepMounted
      >
        <DialogTitle
          id="form-dialog-title"
          onClose={handleCloseDialog}
          style={{
            backgroundColor: SECONDARY_COLOR,
            color: 'white',
          }}
        >
          Imprimir Etiquetas
        </DialogTitle>
        <DialogContent>
          {!carregando ? (
            <ImpressaoTable
              rows={etiquetas}
              statusImpressao={statusImpressao}
              filas={filas}
              filaAtual={filaAtual}
              handleFilaAtual={handleFilaAtual}
              handleStatus={handleStatus}
            />
          ) : (
            <div>carregando</div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
});

export default DialogoCategoriaTransacao;
